<script setup lang="ts">
import { ref, useTemplateRef } from 'vue';

import { Result } from '@/classes/result';

import CustomButton from '@/components/CustomButton.vue';
import router from '@/router';
import { useAuthStore } from '@/stores/auth';
import { processErrorWithFeedback } from '@/utils/error';
import { email, required } from '@/utils/validation';
import LoginBackground from '@/views/auth/LoginBackground.vue';

const authStore = useAuthStore();

const emailInput = ref('');
const passwordInput = ref('');
const isLoading = ref(false);
const form = useTemplateRef('form');

async function handleLogin(): Promise<void> {
    const validationResult = await form.value?.validate();
    if (!validationResult?.valid) return;

    isLoading.value = true;
    try {
        const loginResult: Result = await authStore.login(emailInput.value, passwordInput.value);
        if (loginResult.status !== 200) {
            processErrorWithFeedback(loginResult.message);
        }
    } finally {
        isLoading.value = false;
    }
}
</script>

<template>
    <LoginBackground>
        <v-form ref="form" class="w-100">
            <v-label class="pl-3 font-weight-bold" for="email">E-mailadres</v-label>
            <v-text-field
                type="text"
                name="email"
                id="email"
                autocomplete="username"
                placeholder="Typ hier je e-mailadres"
                :rules="[required, email]"
                v-model="emailInput"
                @keyup.enter="handleLogin"
            />
            <v-label class="pl-3 font-weight-bold" for="password">Wachtwoord</v-label>
            <v-text-field
                type="password"
                name="password"
                id="password"
                autocomplete="current-password"
                :rules="[required]"
                placeholder="Typ hier je wachtwoord"
                @keydown.enter="handleLogin"
                v-model="passwordInput"
            />
            <div class="d-flex align-center justify-center mt-4">
                <CustomButton class="px-10" :loading="isLoading" text="Inloggen" color="main-dark" @click="handleLogin" />
            </div>
        </v-form>
        <a
            @click="router.push('/wachtwoord-vergeten')"
            class="d-flex align-center justify-center text-md-emphasis text-decoration-underline cursor-pointer"
            >Wachtwoord vergeten</a
        >
    </LoginBackground>
</template>
